var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"button is-secondary cta",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.loadWidget()}}},[_vm._v("Book Now")])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }